import { Route } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

export const appRoutes: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: 'queues' },
  {
    path: 'cast',
    loadChildren: () => import('@shareview-health/clinicians/casting').then(m => m.featureClinicianCastingRoutes),
    canActivate: [autoLoginPartialRoutesGuard],
  },
  {
    path: 'queues',
    loadChildren: () => import('@shareview-health/clinicians/queues').then((m) => m.featureClinicianQueuesRoutes),
    canActivate: [autoLoginPartialRoutesGuard],
  },
];
